import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import * as req from 'src/app/entities/request';
import { KeyValueSet, LocalService, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-printer-device-map-popup',
  templateUrl: './printer-device-map-popup.component.html',
  styleUrl: './printer-device-map-popup.component.scss'
})
export class PrinterDeviceMapPopupComponent {
  @ViewChild('content_device_template_map') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() itemId: string | undefined = undefined;
  @Input() businessId: string;
  @Input() ctryCode: string;

  itemSourceTemplates: KeyValueSet[] = []; itemSourceDeviceNames: KeyValueSet[] = [];
  selectedKeys: string[] = []; selectedKey: string = '';
  title: string = '';
  loadedApi = 0;

  htmlId: string = '';
  elementIds: any;

  message: string = ''; isRedAlert: boolean = true;

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private printerService: PrinterService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save_receipt_template: 'save-receipt-template-' + this.htmlId,
      receipt_options: 'receipt-options-' + this.htmlId
    };
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.loadedApi = 0;
    this.onGetTemplate();
    this.onGetPrinterName();
  }

  onGetTemplate() {
    this.itemSourceTemplates = [];
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.getPrinterTemplateMaps(req).subscribe(result => {
      result.forEach(item => {
        this.itemSourceTemplates.push({
          key: item.Key,
          value: item.Title
        } as KeyValueSet);
      });
      this.onLoadItem();
    });
  }

  onGetPrinterName() {
    this.itemSourceDeviceNames = [];
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.getPrinterDevices(req).subscribe(result => {
      result.forEach(item => {
        this.itemSourceDeviceNames.push({
          key: item.Key,
          value: item.Title
        } as KeyValueSet);
      });
      this.onLoadItem();
    });
  }

  onLoadItem() {
    this.loadedApi++;
    if (this.loadedApi == 2) {
      if (this.itemId) {
        const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
        this.printerService.getPrinterDeviceMap(req, this.itemId).subscribe(result => {
          if (result.Mandatory.Status && result.Mandatory.Status == Status.Success) {
            this.title = result.Title;
            this.selectedKeys = result.TemplateMapIds.map(x => x.toString());
            this.selectedKey = result.DeviceId;
            this.onSetSelectedItems();
          }
        });
      } else {
        this.title = '';
        this.selectedKeys = [];
        this.selectedKey = '';
      }
      this.loadedApi++;
    }
  }

  onSetSelectedItems() {
    this.itemSourceTemplates.forEach(item => {
      item.isSelected = this.selectedKeys.includes(item.key);
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        if (this.onDoCheck()) {
          const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode(), Key: this.itemId, Title: this.title.trim(), TemplateMapIds: this.selectedKeys, DeviceId: this.selectedKey } as req.PrinterDeviceMap;
          this.printerService.savePrinterDeviceMap(req).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onCloseTrigger();
            }
          });
        }
      } break;
    }
  }
  onDoCheck(): boolean {
    this.selectedKeys = this.itemSourceTemplates.filter(x => x.isSelected).map(x => x.key);
    let isPassed = true;
    let message = ''
    if (!this.title.trim()) {
      message = this.localService.languageContent.printer.titleRequired;
      isPassed = false;
    } else if (!this.selectedKey) {
      message = this.localService.languageContent.printer.printerNameRequired;
      isPassed = false;
    } else if (this.selectedKeys.length == 0) {
      message = this.localService.languageContent.printer.minReceiptTemplateMapRequired;
      isPassed = false;
    }

    this.message = message;
    return isPassed;
  }
}
